import { render, staticRenderFns } from "./CreateV2.vue?vue&type=template&id=f7a753ea&scoped=true&"
import script from "./js/CreateV2.js?vue&type=script&lang=js&"
export * from "./js/CreateV2.js?vue&type=script&lang=js&"
import style0 from "./CreateV2.vue?vue&type=style&index=0&id=f7a753ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a753ea",
  null
  
)

export default component.exports